import { useContext, useState, useEffect } from "react"
import ModalComponent from "../../../CQIPage/components/ModalComponent"
import styles from "./index.module.scss"
import { TabEditAndHistory } from "../../../CQIPage/components/TabEditAndHistory"
import intl from "react-intl-universal"
import SwitchComponent from "../../../../atoms/Switch"
import { MaximunImprecisun } from "../../../CQIPage/components/MaximunImprecisiun"
import { WestgardRules } from "../../../CQIPage/components/WestgardRules"
import RcmpLoading from "../../../../atoms/Loading"
import Button from "../../../../atoms/Button"
import { WestgardRulesContext } from "../../../../../contexts/Equipments"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import { listHistory } from "../../../../../services/ciq"
import AuthContext from "../../../../../contexts/Auth"
import { HistoryComponent } from "../../../CQIPage/components/HistoryComponent"

export const ModalSettings = ({
  openModal,
  dataAnalyte,
  rules,
  setRules,
  fnUpdateAnalyte,
  isLoading,
  isloadingBtn,
}) => {
  const [isTabEdit, setIsTabEdit] = useState(true)
  const [bActiveSwitch, setIsSwitch] = useState(true)
  const [cTextAmount, setCTextAmount] = useState(dataAnalyte?.eqpanlt_nimprecision_value)
  const [cJustify, setCJustify] = useState(dataAnalyte?.eqpanlt_cjustification)
  const [biologicalVariation, setBiologicalVariation] = useState(false)
  const [manualImprecisium, setManualImprecisium] = useState(true)
  const [bIsError, setBIsError] = useState({
    bIsErrorJustify: false,
    bIsErrorAmount: false,
  })
  const [bActiveMaximumInaccuracy, setBActiveMaximumInaccuracy] = useState(false)

  const [per_pageHistory, setPerPageHistory] = useState(1)
  const [search_type, setSearchType] = useState("")
  const [text_type, setTextType] = useState("")
  const [infoInfinitScroll, setInfoInfinitScroll] = useState({})
  const [dataHistory, setDataHistory] = useState([])
  const [isLoadHistory, setIsLoadHistory] = useState(false)

  const { oUser } = useContext(AuthContext)

  const cUserTimeZone = oUser?.data?.user_ctimezone

  const { setDataConfigAnalyte, isSigma, setIsSigma, listRulesSelectedUnique } =
    useContext(WestgardRulesContext)

  useEffect(() => {
    if (!dataAnalyte) return

    setDataConfigAnalyte(dataAnalyte)
    setIsSigma(dataAnalyte.eqpanlt_bsigma)
    setCTextAmount(dataAnalyte?.eqpanlt_nimprecision_value)
    setCJustify(dataAnalyte?.eqpanlt_cjustification)
    setBActiveMaximumInaccuracy(dataAnalyte?.eqpanlt_bmax_imprecision)

    if (dataAnalyte?.eqpanlt_anlt) {
      setIsSwitch(dataAnalyte.eqpanlt_anlt?.anlt_bstatus)
    }
  }, [dataAnalyte])

  const handleSaveInfo = async () => {
    const data = {
      eqpanlt_eimprecision_type:
        bActiveMaximumInaccuracy && biologicalVariation
          ? "BIOLOGICAL_VARIATION"
          : bActiveMaximumInaccuracy && !biologicalVariation
          ? "MANUAL"
          : "MANUAL",
      eqpanlt_nimprecision_value: cTextAmount,
      eqpanlt_cjustification: cJustify,
      eqpanlt_bmax_imprecision: bActiveMaximumInaccuracy,
      eqpanlt_bstatus: bActiveSwitch,
      eqpanlt_bsigma: isSigma,
      awestgard_rules: listRulesSelectedUnique,
    }

    fnUpdateAnalyte(data)
  }

  const getHistoricHistoric = async (id, perPage, searchType, textType) => {
    try {
      setDataHistory([])
      setIsLoadHistory(true)
      const { data: dt } = await listHistory(
        id,
        perPage,
        searchType,
        textType,
        "equipment-analyte",
      )

      const newDataHistory = dt.data.data.map((item) => {
        const [data, hour] = fnFormatDateFromUTC(
          item.history_dupdated,
          "DD/MM/YYYY - HH:mm",
          cUserTimeZone,
        ).split(" - ")

        return {
          ...item,
          history_caction: item.history_caction,
          history_data: data,
          history_hour: hour,
          history_user_cname: item.history_user?.cname,
        }
      })

      setDataHistory(newDataHistory)

      setInfoInfinitScroll({
        last_page: dt.data.last_page,
        next_page_url: dt.data.next_page_url,
        data_length: dt.data.data.length,
      })
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadHistory(false)
    }
  }

  useEffect(() => {
    if (!dataAnalyte?.eqpanlt_nid) return

    getHistoricHistoric(dataAnalyte.eqpanlt_nid, per_pageHistory, search_type, text_type)
  }, [dataAnalyte, per_pageHistory, search_type, text_type])
  return (
    <ModalComponent
      title={intl.get("ciq.settings_analyte")}
      fnCloseModal={() => openModal(false)}
      size={isTabEdit ? "lg" : "xlg"}
    >
      <TabEditAndHistory isTabEdit={isTabEdit} handleActive={setIsTabEdit} />

      {!dataAnalyte?.eqpanlt_anlt?.anlt_type ? (
        <div style={{ marginTop: "2rem" }}>
          <RcmpLoading bShow={true} size={60} />
        </div>
      ) : isTabEdit ? (
        <>
          <div className={`${styles.flexBetween} ${styles.mbTwoRem}`}>
            <h3 className={styles.titleConfig}>
              {intl.get("ciq.status_analyte_linked_equipment")}
            </h3>

            <SwitchComponent
              width="10rem"
              label="Status"
              onClick={() => {
                setIsSwitch((oldState) => !oldState)
                // setIsChanged(true)
              }}
              cDisabledText={intl.get("ciq.inactive_up")}
              cAbleText={intl.get("ciq.active_up")}
              value={bActiveSwitch}
            />
          </div>

          <div className={styles.flexStart}>
            <div className={`${styles.containerContent} ${styles.widthFiveRem}`}>
              <p className={styles.label}>ID</p>
              <p className={styles.content}>{dataAnalyte?.eqpanlt_anlt_nid}</p>
            </div>
            <div className={`${styles.containerContent} ${styles.widthTenRem}`}>
              <p className={styles.label}>
                {intl.get("ciq.header_table_list_equipment.name")}
              </p>
              <p className={styles.content}>{dataAnalyte?.eqpanlt_anlt?.anlt_cname}</p>
            </div>
            <div className={styles.containerContent}>
              <p className={styles.label}>
                {intl.get("ciq.header_table_link_analytes.type")}
              </p>
              <p className={styles.content}>{dataAnalyte?.eqpanlt_anlt?.anlt_type}</p>
            </div>
            <div />
          </div>
          {dataAnalyte?.eqpanlt_anlt?.anlt_type ===
            intl.get("ciq.types_analytes.quantitative") && (
            <div className={styles.flexStart}>
              <div className={`${styles.containerContent} ${styles.widthFiveRem}`}>
                <p className={styles.label}>Unidade</p>
                <p className={styles.content}>
                  {dataAnalyte?.eqpanlt_anlt.anlt_unit_of_measure}
                </p>
              </div>
              <div className={`${styles.containerContent} ${styles.widthTenRem}`}>
                <p className={styles.label}>
                  {intl.get("ciq.header_table_list_analyte.sector")}
                </p>
                <p className={styles.content}>
                  {dataAnalyte?.eqpanlt_anlt?.anlt_sector?.sector_cname}
                </p>
              </div>
              <div className={styles.containerContent}>
                <p className={styles.label}>
                  {intl.get("ciq.create_analytes.n_decimals")}
                </p>
                <p className={styles.content}>
                  {dataAnalyte?.eqpanlt_anlt.anlt_decimal_places}
                </p>
              </div>
              <div />
            </div>
          )}
          <div className={styles.flexStart}>
            <div className={styles.containerContent}>
              <p className={styles.label}>
                {intl.get("ciq.header_table_list_equipment.observation")}
              </p>
              <p className={styles.content} style={{ fontWeight: 400 }}>
                {dataAnalyte?.eqpanlt_anlt?.anlt_observation}
              </p>
            </div>
          </div>

          {dataAnalyte?.eqpanlt_anlt?.anlt_type !==
            intl.get("ciq.types_analytes.quantitative") && (
            <div className={styles.containerContent}>
              <p className={styles.label}>{intl.get("ciq.opt_results")}</p>
              <div className={styles.start}>
                {dataAnalyte?.eqpanlt_anlt?.anlt_result_options?.map((item) => (
                  <span key={item.resultopt_cdescription} className={styles.cdescription}>
                    {item.resultopt_cdescription}
                  </span>
                ))}
              </div>
            </div>
          )}

          {dataAnalyte?.eqpanlt_anlt?.anlt_type ===
            intl.get("ciq.types_analytes.quantitative") && (
            <MaximunImprecisun
              setIsChanged={() => console.log("setIsChanged")}
              bActiveMaximumInaccuracy={bActiveMaximumInaccuracy}
              setBActiveMaximumInaccuracy={setBActiveMaximumInaccuracy}
              cJustify={cJustify}
              setCJustify={setCJustify}
              cTextAmount={cTextAmount}
              setCTextAmount={setCTextAmount}
              bIsError={bIsError}
              setBIsError={setBIsError}
              biologicalVariation={biologicalVariation}
              setBiologicalVariation={setBiologicalVariation}
              manualImprecisium={manualImprecisium}
              setManualImprecisium={setManualImprecisium}
            />
          )}

          {dataAnalyte?.eqpanlt_anlt?.anlt_type ===
            intl.get("ciq.types_analytes.quantitative") &&
            (isLoading ? (
              <div style={{ marginBottom: "1rem" }}>
                <RcmpLoading bShow={true} size={60} />
              </div>
            ) : (
              <WestgardRules
                isSelectedSigma={dataAnalyte.eqpanlt_bsigma}
                isRulesRequiredSigma={
                  dataAnalyte.eqpanlt_sigma !== null &&
                  dataAnalyte.eqpanlt_covar !== null &&
                  dataAnalyte.eqpanlt_drm !== null
                }
                rules={rules}
                setRules={setRules}
                setIsChanged={() => console.log("setIsChanged")}
              />
            ))}

          <div
            className={styles.flexBetween}
            style={{
              margin: "0rem",
            }}
          >
            <Button variant="outline" onClick={() => openModal(false)}>
              {intl.get("cancel")}
            </Button>
            <Button onClick={handleSaveInfo} isLoading={isloadingBtn}>
              {intl.get("save_settings")}
            </Button>
          </div>
        </>
      ) : (
        <HistoryComponent
          searchHistory="analyte-equipment"
          history={dataHistory}
          infoInfinitScroll={infoInfinitScroll}
          setPerPage={setPerPageHistory}
          perPage={per_pageHistory}
          isLoadHistory={isLoadHistory}
          setSearchType={setSearchType}
          setSearchText={setTextType}
        />
      )}
    </ModalComponent>
  )
}
